import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, Zap, Brain } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-brand-green text-white" data-id="element-168">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-169">
        <FadeIn data-id="element-170">
          <div className="text-center mb-16" data-id="element-171">
            <span className="inline-block py-1 px-3 rounded-full bg-white/10 text-brand-cream font-semibold text-sm tracking-wide mb-4 uppercase" data-id="element-172">
              Resultados Reales
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6" data-id="element-173">
              Lo que cambia en <span className="text-brand-orange" data-id="element-174">7 días</span>
            </h2>
            <p className="text-xl text-brand-cream/80 max-w-2xl mx-auto font-light" data-id="element-175">
              No es magia, es bioquímica aplicada.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-176">
          <FadeIn delay={0.2} direction="up" data-id="element-177">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl text-center h-full hover:bg-white/10 transition-colors" data-id="element-178">
              <div className="w-16 h-16 mx-auto bg-brand-orange/20 rounded-full flex items-center justify-center mb-6" data-id="element-179">
                <Clock className="w-8 h-8 text-brand-orange" data-id="element-180" />
              </div>
              <h3 className="font-serif text-xl font-bold mb-4 text-brand-cream" data-id="element-181">
                Chau Hinchazón
              </h3>
              <p className="text-brand-cream/80 leading-relaxed font-light" data-id="element-182">
                Notarás que la hinchazón matutina desaparece por completo.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="up" data-id="element-183">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl text-center h-full hover:bg-white/10 transition-colors" data-id="element-184">
              <div className="w-16 h-16 mx-auto bg-brand-orange/20 rounded-full flex items-center justify-center mb-6" data-id="element-185">
                <Zap className="w-8 h-8 text-brand-orange" data-id="element-186" />
              </div>
              <h3 className="font-serif text-xl font-bold mb-4 text-brand-cream" data-id="element-187">
                Energía Estable
              </h3>
              <p className="text-brand-cream/80 leading-relaxed font-light" data-id="element-188">
                Tus niveles de energía a la tarde se estabilizan sin bajones.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} direction="up" data-id="element-189">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-2xl text-center h-full hover:bg-white/10 transition-colors" data-id="element-190">
              <div className="w-16 h-16 mx-auto bg-brand-orange/20 rounded-full flex items-center justify-center mb-6" data-id="element-191">
                <Brain className="w-8 h-8 text-brand-orange" data-id="element-192" />
              </div>
              <h3 className="font-serif text-xl font-bold mb-4 text-brand-cream" data-id="element-193">
                Foco Mental
              </h3>
              <p className="text-brand-cream/80 leading-relaxed font-light" data-id="element-194">
                Tu mente se siente más clara. La "niebla mental" queda fuera.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}